import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.access_token) {
        localStorage.setItem("az_token", data.access_token);
      }
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 grid place-items-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-grid place-items-center w-14 h-14 rounded-2xl bg-[#0F3A5A] text-white font-display font-bold text-xl mb-4">
            AZ
          </div>
          <h1 className="font-display text-3xl font-semibold text-slate-900 tracking-tight">
            Admin Login
          </h1>
          <p className="text-slate-500 mt-1.5 text-sm">AZ Pools Dashboard</p>
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-white rounded-3xl p-8 shadow-xl border border-slate-200"
          data-testid="admin-login-form"
        >
          <div className="space-y-4">
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-2">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
                className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#00B4D8] focus:ring-2 focus:ring-[#00B4D8]/20"
              />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
                className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#00B4D8] focus:ring-2 focus:ring-[#00B4D8]/20"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#0F3A5A] hover:bg-[#174E7A] disabled:opacity-60 text-white py-3.5 rounded-xl font-semibold transition"
          >
            <LogIn className="w-4 h-4" />
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <p className="text-center text-xs text-slate-400 mt-6 flex items-center justify-center gap-1.5">
          <Lock className="w-3 h-3" />
          Authorized personnel only
        </p>
      </div>
    </div>
  );
}
